import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import TeamMain from "./TeamMain";
import Footer from "../../components/Footer";

const Team = () => {
  return (
    <>
      <HeaderFour />

      <TeamMain />

      <Footer />
    </>
  );
};

export default Team;
